import { render, staticRenderFns } from "./Complacency.vue?vue&type=template&id=28683481&"
import script from "./Complacency.vue?vue&type=script&lang=js&"
export * from "./Complacency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports